module.exports = __webpack_public_path__ + "static/img/son2.4bdb8daf.png";